import { Injectable } from '@angular/core';
import Organization, { identifier } from '../models/Organization';
import { OrganizationAPIResponse, OrganizationInterface } from '../interfaces/organization';

@Injectable({
  providedIn: 'root'
})

export class OrganizationAdapter {

    public adapterToModel(organizationFHIR: OrganizationAPIResponse) : OrganizationInterface {

      const identifier = this.extractIdentifiers(organizationFHIR.identifier)

      return {
        organization_id: organizationFHIR.organization_id ?? "12345",
        legal_representative: organizationFHIR.legal_representative,
        name: organizationFHIR.name,
        alias: organizationFHIR.alias,
        active: organizationFHIR.active,
        cnpj: identifier.CNPJ ?? '',
        token_id: organizationFHIR.token_id,
        photo : organizationFHIR.photo,
        modifiedDays : organizationFHIR.modifiedDays ?? []
      }
    }


    public adaptToAPIFormat(organizationModel: OrganizationInterface): OrganizationAPIResponse {

      return {
        organization_id: organizationModel.organization_id ?? "12345",
        identifier: [{ value: organizationModel.cnpj, system: 'CNPJ' }],
        legal_representative: organizationModel.legal_representative,
        name: organizationModel.name,
        alias: organizationModel.alias,
        active: organizationModel.active,
        token_id: organizationModel.token_id,
        photo : organizationModel?.photo,
        modifiedDays : organizationModel.modifiedDays ?? []
      }

    }

    private extractIdentifiers(identifiers: identifier[]){

      let CPF: string | null = null;
      let CRM: string | null = null;
      let CNPJ: string | null = null;
  
      identifiers.forEach(identifier => {
          const { system, value } = identifier;
  
          if (system === "CPF") {
            CPF = value;
          } else if (system === "CRM") {
            CRM = value;
          }else if (system === "CNPJ") {
            CNPJ = value;
          }

      });

      return { CPF, CRM, CNPJ };

    }

     


}